/* eslint-disable @typescript-eslint/no-floating-promises */
import { ATTR_NAME } from 'constants/attr-name'
import { EventType } from 'constants/enums'
import { CarComparisonStore } from '../store'
import { TrimSelectorBase } from './trim-selector-base'
import { ComparisonResultsCard } from '../vehicle-card/comparison-results-card'
import { CLASS_NAME } from 'constants/class-names'

/**
 * Trim Selector modal component
 */
export class TrimSelectorComparisonResult extends TrimSelectorBase {
    protected get templateName(): string {
        return 'trim-selector-radio'
    }

    private get resultID(): string {
        return CarComparisonStore.getInstance().lastActiveCard.vehicleCardID
    }

    public constructor(id: string) {
        super(id)
    }

    /**
     * Bind event listeners
     */
    protected bindListeners(): void {
        this.compareButton.addEventListener(EventType.CLICK, () => {
            this.addToMyPicks()
        })
        super.bindListeners()
    }

    /**
     * Handle selector between checkbox and radio
     */
    public handleSelections(): void {
        this.handleRadioButtons()
    }

    /**
     * Handle radiobutton behaviour
     */
    protected handleRadioButtons(): void {
        // Event listener for radio buttons
        this.radiobuttons.forEach((radio) => {
            if (radio.checked) {
                this.onRadiobuttonChecked(radio)
            }

            radio.addEventListener(EventType.CHANGE, () => {
                this.radiobuttons.forEach((radio) => (radio.checked = false))
                this.onRadiobuttonChecked(radio)
            })
        })
    }

    /**
     * Callback to radio button on
     *
     * @param {HTMLInputElement} radio ✅
     */
    protected onRadiobuttonChecked(radio: HTMLInputElement): void {
        radio.checked = true
        radio.focus()

        const vehicleID =
            radio.getAttribute(ATTR_NAME.driving.trimSelector.vehicleId) || ''
        this.checkedItems = []
        this.checkedItems.push(parseInt(vehicleID))
    }

    /**
     * Add to MyPicks
     */
    public async addToMyPicks(): Promise<void> {
        // Remove pre-selected vehicle from my picks
        CarComparisonStore.getInstance().remove(parseInt(this.resultID))

        // Remove pre-selected vehicle in ID slug from url
        this.updatedItems = this.url.pathname
            .split('/')[2]
            .split('-')
            .filter((id) => id !== this.resultID)

        // Add new checked item into my picks
        CarComparisonStore.getInstance().add(this.checkedItems[0])

        // Update ID slug for reloading page
        this.updatedItems.push(this.checkedItems[0].toString())

        // Reset checked items and close modal
        this.checkedItems = []
        this.closeModal()

        // Reload page after update vehicle trim(s)
        this.reloadPage(this.updatedItems.join(','))
    }

    /**
     * Open Trim Selector modal
     * Replace the model information and fetch trims from API
     *
     * @param {string} image Image URL
     * @param {number} year
     * @param {string} make
     * @param {string} model
     */
    public async openTrimSelector(card: ComparisonResultsCard): Promise<void> {
        void this.handleTrimSelector(card)
    }

    public setVehicleIcons(): void {
        // The vehicle icons on trim selector modal will be hidden if the my picks session is not matched with result page
        this.myPicksWrapper.classList.add(CLASS_NAME.common.hidden)
    }
}
